import { Divider } from 'antd';
import transitionImg from '@/assets/images/simulation/transition_arrow.png';
import styles from './single.module.scss';
import SimulationImg from '../../../components/SimulationImg';
const CardListEqualOne = (props) => {
    let { reportCards = [] } = props;

    return (
        <>
            <div>
                {reportCards.map((ele, index) => {
                    return (
                        index === 0 && (
                            <div key={index} className={styles.card}>
                                <div className={styles.cardFront}>
                                    <div className={styles.left}>
                                        <div className={styles['event-index']}>{index > 9 ? index + 1 : '0' + (index + 1)}</div>
                                        <div className={styles['event-title']}>{ele.scenario_title}</div>
                                        <div className={styles['event-content']}>{ele.scenario_description}</div>
                                    </div>
                                    <div className={styles['right']}>
                                        <SimulationImg className={styles['event-img']} src={ele.scenario_image} alt={ele.scenario_title} />
                                    </div>
                                </div>

                                <div className={styles.cardBack}>
                                    <div className={styles['left']}>
                                        <div className={styles['choice-index']}>
                                            {index > 9 ? index + 1 : '0' + (index + 1)}
                                            <div className={styles['choice-title']}>你的选择</div>
                                        </div>

                                        <div className={styles['choice']}>{ele?.choice_path}</div>
                                    </div>

                                    <div className={styles['choice-split-line']}>
                                        <div className={styles['choice-split-line-item']}></div>
                                        <img src={transitionImg} alt={ele.scenario_title} />
                                        <div className={styles['choice-split-line-item']}></div>
                                    </div>
                                    <div className={styles['right']}>
                                        <div className={styles['choice-index']}>产生影响</div>

                                        <div className={styles['choice-content']}>{ele?.impact_analysis}</div>
                                    </div>
                                </div>
                            </div>
                        )
                    );
                })}
            </div>
        </>
    );
};
export default CardListEqualOne;
